import Base from '../../ts/_base';

export default class SelectableDropdown extends Base {

    constructor(wrapper) {
        super();
    }

    initialize(): void {
        const event = new Event('change');
        const DROPDOWN_TOGGLE = '.dropdown-toggle, .tabs-toggle';
        $('body').on('click', '.dropdown-selectable .dropdown-item', function (e) {
            if (e.currentTarget.getAttribute('href') === '#') {
                e.preventDefault();
            }
            const $this = $(this);
            const $toggle = $this.closest('.dropdown-selectable').find(DROPDOWN_TOGGLE);
            $toggle.text($this.text());
            $this.siblings().removeClass('active');
    
            const formControl = $this.closest('.dropdown-selectable--form-control');
            if (formControl.length > 0) {
                let input = formControl.find('input');
                input.val($this.data('value'));
                input.get(0).dispatchEvent(event);
            }
        });
    }
}
